import { createFileRoute, useParams } from '@tanstack/react-router';

import { LocationCreateScreen } from '@/features/locations/components/workspace/LocationCreateScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/organizations/$orgId/locations/new')({
  beforeLoad: () => {
    requirePermission('location:create');
  },
  component: WorkspaceLocationCreateRoute,
  staticData: { crumb: 'New location' },
});

function WorkspaceLocationCreateRoute() {
  const { orgId } = useParams({
    from: '/_staff/admin/workspace/organizations/$orgId/locations/new',
  });
  return <LocationCreateScreen orgId={orgId} />;
}
